import { Delete } from "lucide-react";
import { cn } from "@/lib/utils";

const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "", "0", "del"];

export const PinDots = ({ length, error }) => (
  <div className={cn("flex gap-4 justify-center", error && "animate-[shake_0.4s_ease]")} data-testid="pin-dots">
    {[0, 1, 2, 3].map((i) => (
      <span key={i} className={cn("w-4 h-4 rounded-full border-2 transition-colors", i < length ? "bg-[var(--coffee)] border-[var(--coffee)]" : "border-[var(--coffee-muted)]", error && "border-[var(--coral)] bg-[var(--coral)]")} />
    ))}
  </div>
);

export const PinKeypad = ({ value, onChange, disabled, testId = "pin" }) => {
  const press = (k) => {
    if (disabled) return;
    if (k === "del") return onChange(value.slice(0, -1));
    if (value.length < 4) onChange(value + k);
  };
  return (
    <div className="grid grid-cols-3 gap-3 max-w-[260px] mx-auto" data-testid={`${testId}-keypad`}>
      {KEYS.map((k, i) => k === "" ? <span key={i} /> : (
        <button key={k} type="button" onClick={() => press(k)} disabled={disabled} data-testid={`${testId}-key-${k}`}
          className="h-16 rounded-full serif text-3xl text-[var(--coffee)] bg-[var(--cream-card)] border border-[var(--line)] flex items-center justify-center transition-[transform,background-color] active:scale-95 active:bg-[var(--cream-surface)] disabled:opacity-40">
          {k === "del" ? <Delete size={22} /> : k}
        </button>
      ))}
    </div>
  );
};
